module.exports = __webpack_public_path__ + "static/footer-logos-04651acf66d8e4e6d434a08cb55c8e7a.svg";